import { render, staticRenderFns } from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=template&id=22d91e80&scoped=true"
import script from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=script&lang=js"
export * from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=script&lang=js"
import style0 from "./CombosPlusGeneradosImportAsignacion.vue?vue&type=style&index=0&id=22d91e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d91e80",
  null
  
)

export default component.exports